import { useWidgetPostMessages } from '@widgets/messenger/utils/postMessages'

export interface OpenLinkPayload {
  href: string
  openInNewWindow: boolean
}

const useOpenLinkMessages = (widgetId: string) => useWidgetPostMessages<OpenLinkPayload>(widgetId, 'textmagicOpenLink')

export const sendOpenLinkMessage = (widgetId: string, href: string, openInNewWindow: boolean) => {
  useOpenLinkMessages(widgetId).sendToParent({ href, openInNewWindow })
}

export const subscribeOnOpenLinkMessages = (widgetId: string, callback: (payload: OpenLinkPayload) => void) => {
  return useOpenLinkMessages(widgetId).subscribe((event) => {
    callback(event.data.payload)
  })
}

// TODO: delete after widget-script.ts cache update
const useOpenLinkSupportMessages = (widgetId: string) =>
  useWidgetPostMessages<boolean>(widgetId, 'textmagicCheckOpenLinkSupport')

export const checkParentSupportsOpenLink = async (widgetId: string): Promise<boolean> => {
  return new Promise((resolve) => {
    const supportMessages = useOpenLinkSupportMessages(widgetId)

    const unsubscribe = supportMessages.subscribe((event) => {
      unsubscribe()
      resolve(event.data.payload)
    })

    supportMessages.sendToParent(true)

    setTimeout(() => {
      unsubscribe()
      resolve(false)
    }, 50)
  })
}

// TODO: delete after widget-script.ts cache update
export const subscribeOnOpenLinkSupportMessages = (widgetId: string, callback: (payload: boolean) => void) => {
  return useOpenLinkSupportMessages(widgetId).subscribe((event) => {
    callback(event.data.payload)
  })
}
